interface SettingsJson {
	widgetAccess: string;
	employeeIdLabel: string;
}

const subTypeOptions = [
	"SUBSCRIPTIONS",
	"HOUSING_COOPERATIVE_AGREEMENT",
] as const;

export type SubTypeId = (typeof subTypeOptions)[number];

export const parseSubTypeId = (value: string): SubTypeId => {
	const subTypeId = subTypeOptions.find((x) => x === value);

	if (!subTypeId) {
		throw new Error("Could not find agreement subTypeId is undefined");
	}

	return subTypeId;
};

export interface AgreementJson {
	id: string;
	subTypeId: string;
	invoiceReference: string;
	settings: SettingsJson;
}

export const getValidAgreementJson = ({
	id = "1-4591621850",
	subTypeId = "SUBSCRIPTIONS",
	widgetAccess = "ALLOW_TICKET_REQUESTS",
	employeeIdLabel = "Ansattnr.",
} = {}): AgreementJson => ({
	id,
	subTypeId,
	invoiceReference: "",
	settings: {
		widgetAccess,
		employeeIdLabel,
	},
});
